import axios from "axios";
import InvoiceStateDTO from "@/models/InvoiceStateDTO";
import PaymentVariantDTO from "@/models/PaymentVariantDTO";

export default class APIClient {
    ping = async (baseURL: string): Promise<any> => {
        let resp = await axios({
            baseURL,
            url: `/api/public/ping`,
            method: 'GET',
        });

        return resp.data;
    }

    getInvoice = async (invoiceId: string, ua: string): Promise<InvoiceStateDTO> => {
        let resp = await axios({
            url: `/api/public/invoices/${invoiceId}`,
            method: 'POST',
            headers: {'X-HTTP-METHOD-OVERRIDE': "GET"},
            data: {
                ua: ua
            }
        });

        return resp.data as InvoiceStateDTO;
    }

    createInvoice = async (data: any, apiKey: string): Promise<string> => {
        let resp = await axios({
            url: `/api/merchant/invoices`,
            method: 'POST',
            data,
            headers: {
                'X-Identity': apiKey
            }
        });

        return resp.data.invoiceUrl as string;
    }

    openDispute = async (invoiceId: string, form: FormData): Promise<InvoiceStateDTO> => {
        let resp = await axios({
            url: `/api/public/invoices/${invoiceId}/open-dispute`,
            method: 'POST',
            data: form,
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return resp.data as InvoiceStateDTO;
    }

    setDisputeAttachment = async (invoiceId: string, form: FormData): Promise<InvoiceStateDTO> => {
        let resp = await axios({
            url: `/api/public/invoices/${invoiceId}/dispute-attachment`,
            method: 'POST',
            data: form,
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return resp.data as InvoiceStateDTO;
    }

    getAvailableMethods = async (invoiceId: string): Promise<string[]> => {
        let resp = await axios({
            url: `/api/public/invoices/${invoiceId}/available-methods`,
            method: 'GET',
        })

        return resp.data as string[]
    }

    getAvailablePaymentVariants = async (invoiceId: string): Promise<PaymentVariantDTO[]> => {
        let resp = await axios({
            url: `/api/public/invoices/${invoiceId}/available-payment-variants`,
            method: 'GET',
        })

        return resp.data as PaymentVariantDTO[]
    }

    startDeal = async (invoiceId: string, method: string|null, options?: {paymentOption?: string, userCard?: string, userPhone?: string, crossBorderCurrency?: string}): Promise<InvoiceStateDTO> => {
        const data: any = {
            'paymentMethod': method
        };
        
        if (options?.paymentOption) {
            data.paymentOption = options.paymentOption;
        }
        
        if (options?.userCard) {
            data.userCard = options.userCard;
        }

        if (options?.userPhone) {
            data.userPhone = options.userPhone;
        }

        if (options?.crossBorderCurrency) {
            data.crossBorderCurrency = options.crossBorderCurrency;
        }

        let resp = await axios({
            url: `/api/public/invoices/${invoiceId}/start-deal`,
            data,
            method: 'POST',
        })

        return resp.data as InvoiceStateDTO
    }

    proceed3ds2 = async (invoiceId: string, payload: any): Promise<{acsUrl: string, cReq: string}> => {
        let resp = await axios({
            url: `/api/public/invoices/${invoiceId}/3ds2-proceed`,
            method: 'POST',
            data: payload,
        })

        return resp.data as {acsUrl: string, cReq: string}
    }

    sendAcquiringCode = async (invoiceId: string, code: string): Promise<InvoiceStateDTO> => {
        let resp = await axios({
            url: `/api/public/invoices/${invoiceId}/acquiring-code`,
            method: 'POST',
            data: {
                code: code
            }
        })

        return resp.data as InvoiceStateDTO
    }

    cancelDeal = async (invoiceId: string, dealId: string): Promise<InvoiceStateDTO> => {
        let resp = await axios({
            url: `/api/public/invoices/${invoiceId}/cancel-deal`,
            data: {
                'dealId': dealId
            },
            method: 'POST',
        })

        return resp.data as InvoiceStateDTO
    }

    cancelInvoice = async (invoiceId: string): Promise<InvoiceStateDTO> => {
        let resp = await axios({
            url: `/api/public/invoices/${invoiceId}/cancel`,
            method: 'POST',
        })

        return resp.data as InvoiceStateDTO
    }

    confirmTransfer = async (invoiceId: string, dealId: string, file: any = null, transactionId?: string | null): Promise<InvoiceStateDTO> => {
        const formData = new FormData();
        if (file) {
            formData.append('attachment', file)
        }
        formData.append('dealId', dealId)
        
        if (transactionId) {
            formData.append('transactionId', transactionId)
        }

        let resp = await axios({
            url: `/api/public/invoices/${invoiceId}/confirm-transfer`,
            data: formData,
            method: 'POST',
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })

        return resp.data as InvoiceStateDTO
    }

}